import _ from 'lodash';

import { THEME } from '../../constants/notification';
import { mediaAssetsService } from '../../transport/services/media-assets.service';
import { ACL, FileDescriptor, Project } from '../../types/entities';
import { i18n } from '../../utils/index';
import { Dispatch } from '../redux.types';

import { FILES_ACTIONS } from './files.actions';

const updateFileACLSuccess = (payload) => ({
  type: FILES_ACTIONS.FILE_ACL_UPDATE_SUCCESS,
  payload,
  notification: {
    message: i18n.t('notifications.media-assets.file.update-acl.success'),
    theme: THEME.SUCCESS,
  },
});

const updateFileACLError = (payload) => ({
  type: FILES_ACTIONS.FILE_ACL_UPDATE_ERROR,
  payload,
  notification: {
    message: i18n.t('notifications.media-assets.file.update-acl.error'),
    theme: THEME.ERROR,
  },
});

interface IUpdateFileACLInternal {
  acl: ACL;
  id: string;
  organizationId: string;
  project: Project;
}

export const updateFileACLInternal =
  ({ acl, id, organizationId, project }: IUpdateFileACLInternal) =>
  (dispatch: Dispatch) => {
    mediaAssetsService.updateFileACL({ acl, id, project, organizationId }).then(
      (response: FileDescriptor) => dispatch(updateFileACLSuccess(response)),
      ({ response }) => dispatch(updateFileACLError(_.get(response, 'data'))),
    );
  };
